import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.define-property";

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError('Cannot instantiate an arrow function');
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

export var Events =
/*#__PURE__*/
function () {
  function Events(eventType, runCallbacks) {
    var _this = this;

    _classCallCheck(this, Events);

    this.running = false;

    this.handleEvent = function () {
      _newArrowCheck(this, _this);

      if (!this.running) {
        this.running = true;

        if (typeof window !== 'undefined' && window.requestAnimationFrame) {
          window.requestAnimationFrame(this.runCallbacks);
        } else {
          setTimeout(this.runCallbacks, 200);
        }
      }
    }.bind(this);

    typeof window !== 'undefined' && window.addEventListener(eventType, this.handleEvent);
    this.runCallbacks = runCallbacks;
  }

  _createClass(Events, [{
    key: 'setRunning',
    value: function setRunning() {
      this.running = false;
    }
  }]);

  return Events;
}();